const utils = require('../../utils/utils.js');
export default {
    data() {
        return {
            baseUrl: this.$global.baseUrl,
            currentOrg: {
                id: "",
                name: "全部",
                orgType: 1,
                fullPathId: ""
            },
            searchContent: "",
            pageIndex: 1,
            pageSize: 10,
            total: 0,
            tableData: [],
            multipleSelection: [],
            dialogManageShow: false,
            manageForm: {},
            tree: null,
            dialogPostChangeVisible: false,
            postChangeForm: { orgId: "", userId: "" },
            orgTree: [],
        }
    },
    mounted: function () {
        this.requestTreeData();
        this.query();
    },
    methods: {
        /**
         * 点击事件
         * @param {*} id 
         */
        clickEvent: function (id, data) {
            switch (id) {
                case "resetOrg": //重置机构
                    this.currentOrg = {};
                    this.pageIndex = 1;
                    this.query();
                    break;
                case "search": //搜索
                    this.pageIndex = 1;
                    this.query();
                    break;
                case "add": //添加
                    if (this.currentOrg.id == "" || this.currentOrg.orgType != 3) {
                        this.$message.closeAll();
                        this.$message.warning("请先在左侧选定岗位");
                        return;
                    }
                    this.manageForm = {};
                    this.dialogManageShow = true;
                    break;
                case "edit": //编辑
                    if (this.multipleSelection.length != 1) {
                        this.$message.closeAll();
                        this.$message.warning("请选择一项进行修改");
                        return;
                    }
                    this.manageForm = Object.assign({}, this.multipleSelection[0]);
                    this.manageForm.fileInfoPath = this.manageForm.avatar;
                    this.dialogManageShow = true;
                    break;
                case "manageConfirm": //确定
                    this.$refs['manageForm'].validate((valid) => {
                        if (valid) {
                            if (this.manageForm.fileInfoPath == null || this.manageForm.fileInfoPath == '') {
                                this.$message.closeAll();
                                this.$message.warning("请上传头像文件");
                                return;
                            }
                            this.saveOrUpdate();
                        } else {
                            return false;
                        }
                    });
                    break;
                case "delete": //删除
                    if (this.multipleSelection.length == 0) {
                        this.$message.closeAll();
                        this.$message.warning("请至少选择一项进行删除");
                        return;
                    }
                    this.$confirm('此操作将删除所选中的人员, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.delete();
                    }).catch(() => { });
                    break;
                case "resetPassword": //密码重置
                    this.$confirm('此操作将重置当前人员密码, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.resetPassword(data.id);
                    }).catch(() => { });
                    break;
                case "postChange": //岗位变更
                    this.postChangeForm = { orgId: "", userId: data.id };
                    this.dialogPostChangeVisible = true;
                    this.orgTree = this.tree;
                    this.toOrgTree(this.orgTree);
                    break;
                case "postChangeConfirm": //岗位变更点击确定
                    this.$refs['postChangeForm'].validate((valid) => {
                        if (valid) {
                            this.requestPostChange();
                        } else {
                            return false;
                        }
                    });
                    break;
                default:
                    break;
            }
        },

        /**
         * 文件上传之前处理
         * @param {*} file 
         */
        handleBeforeUpload: function (file) {
            //判断文件图片类型
            if (file.type.indexOf("jpg") == -1 && file.type.indexOf('png') == -1 && file.type.indexOf('jpeg') == -1) {
                this.manageForm.fileList = [];
                this.$message.closeAll();
                this.$message.error("只能上传图片格式文件");
                return false;
            }
            //判断文件是否大于2M
            if (file.size > 2 * 1024 * 1024) {
                this.manageForm.fileList = [];
                this.$message.closeAll();
                this.$message.error("文件大小不能超过2M");
                return false;
            }
        },

        /**
         * 上传失败
         * @param {*} files 
         * @param {*} fileList 
         */
        handleError: function (err, file, fileList) {
            this.$message.closeAll();
            this.$message.error("上传失败");
        },

        /**
         * 上传成功
         * @param {*} response 
         * @param {*} file 
         * @param {*} fileList 
         */
        handleSuccess: function (response, file, fileList) {
            if (response.success) {
                var manageForm = Object.assign({}, this.manageForm);
                manageForm.fileList = [];
                manageForm.fileInfoId = response.data.id;
                manageForm.fileInfoPath = response.data.path;
                this.manageForm = manageForm;
                this.$refs.upload.clearFiles();
            } else {
                this.$message.closeAll();
                this.$message.error(response.message);
            }
        },

        /**
         * 获取年龄
         * @param {*} idNumber 
         */
        getYearOld: function (idNumber) {
            return utils.getAge(idNumber);
        },

        /**
         * 格式化日期
         */
        formatDate: function (str) {
            return str.substring(0, 10)
        },

        /**
         * 递归构造tree数据
         * @param {*} data 
         */
        toTree: function (data) {
            data.forEach(function (item) {
                delete item.children;
            });

            var map = {};
            data.forEach(function (item) {
                map[item.id] = item;
            });
            var val = [];
            data.forEach(function (item) {
                // 以当前遍历项，的parentId,去map对象中找到索引的id
                var parent = map[item.parentId];
                if (parent) {
                    (parent.children || (parent.children = [])).push(item);
                } else {
                    val.push(item);
                }
            });
            return val;
        },

        /**
         * 递归处理tree数据
         * @param {*} data 
         */
        toOrgTree: function (data) {
            data.forEach(item => {
                if (item.children == null || item.children.length == 0) {
                    if (item.orgType != 3) {
                        item.disabled = true;
                    }
                } else {
                    this.toOrgTree(item.children);
                }
            })
        },

        /**
         * 左侧树点击事件
         * @param {*} node 
         * @param {*} nodeObj 
         * @param {*} comp 
         */
        treeClick: function (node, nodeObj, comp) {
            this.currentOrg = {
                fullPathId: node.fullPathId,
                fullPathName: node.fullPathName,
                orgType: node.orgType,
                name: node.name,
                id: node.id
            };
            this.pageIndex = 1;
            this.query();
        },

        /**
         * 表格选中事件
         * @param {*} val 
         */
        tableColumnCheckEvent: function (val) {
            this.multipleSelection = val;
        },

        /**
         * 翻页操作
         */
        handlePageChange: function (val) {
            this.pageIndex = val;
            this.query();
        },

        /**
         * 岗位变更用户组织机构选择
         * @param {*} val 
         */
        postChangeOrgHandleChange: function (val) {
            this.postChangeForm.orgId = val[val.length - 1];
        },

        /**
         * 查询左侧树列表
         */
        requestTreeData: function () {
            this.$get({
                url: 'org/list',
                params: {}
            }).then(response => {
                //递归解析tree数据
                this.tree = this.toTree(response);
            });
        },

        /**
         * 新增或修改
         */
        saveOrUpdate: function () {
            this.$post({
                url: "/user/saveOrUpdate",
                params: {
                    id: this.manageForm.id,
                    orgId: this.currentOrg.id || this.manageForm.orgId,
                    avatarPath: this.manageForm.fileInfoPath,
                    name: this.manageForm.name,
                    gender: this.manageForm.gender,
                    phone: this.manageForm.phone,
                    idNumber: this.manageForm.idNumber,
                    userType: this.manageForm.userType
                }
            }).then(res => {
                this.manageForm = {};
                this.dialogManageShow = false;
                this.$message.closeAll();
                this.$message.success("添加成功");
                this.query();
            });
        },

        /**
         * 批量删除
         */
        delete: function () {
            var ids = new Array();
            this.multipleSelection.forEach(elem => {
                ids.push(elem.id);
            });
            this.$post({
                url: "/user/delete",
                params: {
                    ids: ids
                }
            }).then(res => {
                this.$message.closeAll();
                this.$message.success("删除成功");
                this.query();
            });
        },

        /**
         * 查询
         */
        query: function () {
            this.$post({
                url: 'user/queryByPage',
                params: {
                    keyWord: this.searchContent,
                    userType: 0,
                    fullOrgId: this.currentOrg.fullPathId,
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize
                }
            }, true).then(response => {
                this.total = response.total;
                this.tableData = response.data;
            });
        },

        /**
         * 密码重置
         * @param {*} id 
         */
        resetPassword: function (id) {
            this.$post({
                url: 'user/resetPassword',
                params: {
                    id: id
                }
            }, true).then(response => {
                this.$message.closeAll();
                this.$message.success("密码已重置");
            });
        },

        /**
         * 请求岗位变更
         */
        requestPostChange: function () {
            var userId = this.postChangeForm.userId;
            var orgId = this.postChangeForm.orgId;
            this.$post({
                url: 'user/postChange',
                params: {
                    id: userId,
                    orgId: orgId
                }
            }, true).then(response => {
                this.dialogPostChangeVisible = false;
                this.$message.closeAll();
                this.$message.success("变更成功");
                this.pageIndex = 1;
                this.query();
            });
        }
    }
}